<template>
<div class="yk-single-con">

    <el-form-item :label="'题目'+(index+1)+'：多选题'" class='yk-Multiselect-title' style='margin-bottom: 10px;'>
        <Editor v-model="form.questionTitle" placeholder="请输入题干"/>
    </el-form-item>

    <el-form-item label="选项" class="yk-radioChoice" style='border:0'>
        <el-form-item label-width="30px" v-for="(item,index) in form.radioData" :key="index">
            <el-checkbox>{{alphabet[index]}}</el-checkbox>
            <div class="yk-input-show">
              <el-input v-model="form.radioData[index]" placeholder="">
                <el-checkbox-group v-model="form.radio" v-if='form.radio.indexOf(index)>-1' slot="append">
                  <el-checkbox-button :label="index" @change="add
                  ">正确答案</el-checkbox-button>
                </el-checkbox-group>
                <el-checkbox-group v-model="form.radio" v-else slot="append">
                  <el-checkbox-button :label="index" @change="add
                  ">设为正确答案</el-checkbox-button>
                </el-checkbox-group>
              </el-input>
            </div>
            <i class="el-icon-close" @click="closeChoice(index)" v-if="form.radioData.length > 2"></i>
        </el-form-item>
    </el-form-item>

    <el-form-item label="" class='yk-add-item'>
        <el-button type="primary" @click="addChoice()" icon='el-icon-circle-plus-outline'>添加选项</el-button>
    </el-form-item>
    <!-- <el-form-item label="答案：" >
      <span v-for="CheckValue in form.radio" :key="CheckValue">{{alphabet[CheckValue]}}</span>
    </el-form-item> -->

    <el-form-item label="解析" style='margin-bottom:0'>
        <Editor v-model="form.analysisContent" placeholder="请输入内容"/>
    </el-form-item>
    <el-form-item label="" class='yk-multiselect-delete'>
      <el-button type="primary" @click="remove()" style="float:right" icon='el-icon-delete'>删除题目</el-button>
    </el-form-item>
</div>
</template>

<script>
// import Vue from 'vue';
export default {
  // name: 'multiselects',
  props: {
    iSubmit: {
      type: Boolean,
      default: false
    },
    IsAnswers: {
      type: Boolean,
      default: true
    },
    sortOrder: {
      type: Number,
      default: 0
    },
    childQuestion: {
      tyoe: Object,
      default: null
    },
    showChoice: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.form = this.childQuestion;
  },
  data() {
    return {
      content: '请输入内容',
      formOption: {
        choice: null
      },
      a: 1,
      CheckValues: [],
      check: [],
      alphabet: [
        'A.',
        'B.',
        'C.',
        'D.',
        'E.',
        'F.',
        'G.',
        'H.',
        'I.',
        'J.',
        'K.',
        'L.',
        'M.',
        'N.',
        'O.',
        'P.',
        'Q.',
        'R.',
        'S.',
        'T.',
        'U.',
        'V.',
        'W.',
        'X.',
        'Y.',
        'Z.'
      ],
      stuAnswer: [],
      form: {
        questionTitle: '',
        radio: [], // 多选题答案
        radioData: ['', '', '', ''], // 单选与多选的框
        correctAnswer: '',
        analysisContent: '',
        sortOrder: 0,
        QuestionType: 2
      }
    };
  },
  watch: {
    iSubmit: function(val) {
      if (val) {
        this.$emit('done', {
          form: this.form
        });
      }
    },
    showChoice: function(val) {
      if (val) {
        this.form = this.childQuestion;
      } else {
        this.form ={
          questionTitle: '',
          radio: [], // 单选题题答案
          radioData: ['', '', '', ''], // 单选与多选的框
          correctAnswer: '',
          analysisContent: '',
          sortOrder: 0
        };
      }
    }
  },
  methods: {
    // 添加选项
    addChoice: function() {
      this.form.radioData.push('');
    },
    // 删除选项
    closeChoice: function(index) {
      this.form.radioData.splice(index, 1);
      this.form.radio.splice(index, 1);
    },
    // 添加正确答案
    addCheckValue: function() {
      if (this.form.radio.length <=1) {
        return;
      }
      this.form.radio.sort();
    },
    remove: function() {
      this.$emit('remove', this.index);
    }
  }
};
</script>

<style lang="scss">

.yk-single-con {
  .el-form-item .el-form-item {
    margin-bottom: 20px;
  }
  .yk-radioChoice{
    display:inline-block;
  }
  .yk-input-show {
     display:inline-block;
     width:520px;
    .el-input {
      width: 85%;
      margin-left: 15px;
    }
  }
  i.el-icon-close {
    font-size: 16px;
    margin-left: 10px;
  }

  .el-col .yk-addChoice {
    margin-left: 70px;
    color: #606266;
  }
  .yk-radioChoice {
    .yk-op-choice-child {
      margin-top: 4px;
      label,
      .yk-input-show,
      i {
        display: inline-block;
      }
      .yk-input-show {
        width: 560px;
      }
    }
  }
}
</style>

